// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInSeconds as fn } from "../differenceInSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInSecondsWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInSecondsWithOptions;
